import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LazyLoadDirective } from './lazy-load.directive';
import { LoadModuleReferences } from './models/load-module-reference.model';
import { LAZY_MODULE_COMPONENT_REFERENCE } from './tokens';

@NgModule({
    declarations: [LazyLoadDirective],
    imports: [
        CommonModule
    ],
    exports: [LazyLoadDirective],
})
export class LazyLoadModule {
    static add(lazyModules?: LoadModuleReferences): ModuleWithProviders<LazyLoadModule> {
        return {
            ngModule: LazyLoadModule,
            providers: [
                {
                    provide: LAZY_MODULE_COMPONENT_REFERENCE,
                    useValue: lazyModules,
                    multi: true
                }
            ]
        };
    }
}
